import React, { useState, useEffect, useRef } from "react";
// Api
import {
  getUsers,
  updateUser,
  createUser,
  deleteUser,
  resendUserInvitation,
} from "../../../../../../api/configuration"; // Importa el método `toggleUserPin`
// Components
import { useDispatch, useSelector } from "react-redux";
import { setAlert } from "../../../../../../reducers/userConfigSlice";

import { GoPlus } from "react-icons/go";
import { LuLockKeyhole } from "react-icons/lu";
import Popup from "../../../../../../components/popup";
import "./reference.css";

const UserInput = ({
  id,
  type,
  classname = "",
  label,
  defaultValue,
  placeholder,
}) => (
  <div className="inputType2Container">
    <label className="inputLabel" htmlFor={id}>
      {label}
    </label>
    <div className="input-container">
      <input
        id={id}
        type={type}
        className={`inputType2 ${classname}`}
        autoComplete="off"
        defaultValue={defaultValue ?? ""}
        placeholder={placeholder}
      />
    </div>
  </div>
);

const EditionUser = ({ data }) => {
  return (
    <div className="editionUserBlock">
      <div className="row">
        <div className="col-md-12">
          <div className="configurationPanelContentTitle">
            Información del usuario
          </div>
        </div>
        <div className="col-md-3 col-sm-12">
          <UserInput
            id={"name"}
            type={"text"}
            placeholder=""
            icon={null}
            classname={""}
            iconPositionRight={true}
            label="Nombre del usuario"
            description=""
            defaultValue={data.fullname && data.fullname}
          />
        </div>
        <div className="col-md-3 col-sm-12">
          <UserInput
            id={"email"}
            type={"text"}
            placeholder=""
            icon={null}
            classname={""}
            iconPositionRight={true}
            label="Correo electrónico"
            description=""
            defaultValue={data.email && data.email}
          />
        </div>
        <div className="col-md-3 col-sm-12">
          <UserInput
            id={"phone"}
            type={"text"}
            placeholder=""
            icon={null}
            classname={""}
            iconPositionRight={true}
            label="Teléfono de contacto"
            description=""
            defaultValue={data.phone && data.phone}
          />
        </div>
        <div className="col-md-3 col-sm-12">
          <label className="inputLabel" htmlFor="role">
            Rol
          </label>
          <select
            id="role"
            className="inputType2"
            defaultValue={data.role || "employee"}
          >
            <option value="employee">Empleado</option>
            <option value="manager">Encargado</option>
            <option value="admin">Administrador</option>
          </select>
        </div>
        <div className="col-md-12 pt-4">
          <div className="row">
            <div className="col-md-12 mb-2">
              <b>Plataformas</b>
            </div>
          </div>
          <div className="flex-start" style={{ gap: "20px" }}>
            <div className="">
              <input
                id="platform-tpv"
                type="checkbox"
                className="custom-checkbox"
                defaultChecked={Boolean(data.platformPermissions?.tpv)}
              />{" "}
              <label htmlFor="platform-tpv">Punto de venta</label>
            </div>
            <div className="">
              <input
                id="platform-kitchen"
                type="checkbox"
                className="custom-checkbox"
                defaultChecked={Boolean(data.platformPermissions?.kitchen)}
              />{" "}
              <label htmlFor="platform-kitchen">Gestor de pedidos</label>
            </div>
            <div className="">
              <input
                id="platform-delivery"
                type="checkbox"
                className="custom-checkbox"
                defaultChecked={Boolean(data.platformPermissions?.delivery)}
              />{" "}
              <label htmlFor="platform-delivery">Repartidor</label>
            </div>
          </div>
        </div>
        <div className="col-md-12 pt-4">
          <div className="configurationPanelContentTitle">Código PIN</div>
        </div>
        <div
          className="col-md-12"
          style={{ alignItems: "center", display: "flex", gap: "25px" }}
        >
          <div>
            <label className="inputLabel" htmlFor="pinActivation">
              Activo
            </label>
            <input
              type="checkbox"
              className="custom-checkbox mt-1"
              id="pinActivation"
              defaultChecked={Boolean(data.activePin ?? true)}
              aria-describedby="pinActivationReason"
            />
            <p id="pinActivationReason">
              Desactivar bloquea TPV, cocina y reparto y conserva el PIN. El
              acceso al Admin por email no cambia.
            </p>
          </div>
          <div style={{ width: "300px" }}>
            <UserInput
              id={"pinCode"}
              type={"password"}
              placeholder=""
              icon={null}
              classname={""}
              iconPositionRight={true}
              label="Pin de 4 dígitos"
              description=""
              defaultValue={data.pin}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const PinCell = ({ pin, allowed, name }) => {
  const [visible, setVisible] = useState(false);
  const valid = typeof pin === "string" && /^\d{4}$/.test(pin);
  useEffect(() => {
    setVisible(false);
  }, [pin, allowed]);
  useEffect(() => {
    if (!visible) return;
    const timer = setTimeout(() => setVisible(false), 15000);
    return () => clearTimeout(timer);
  }, [visible]);
  if (!valid)
    return (
      <span>{pin === null || pin === "" ? "Sin PIN" : "No disponible"}</span>
    );
  return (
    <div
      className="usersPin"
      onBlur={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget))
          setVisible(false);
      }}
    >
      <span aria-label={visible ? "PIN visible" : "PIN oculto"}>
        {visible && allowed ? pin : "••••"}
      </span>
      {allowed && (
        <button
          type="button"
          aria-label={`${visible ? "Ocultar" : "Ver"} PIN de ${name}`}
          aria-pressed={visible}
          onClick={() => setVisible((previous) => !previous)}
        >
          {visible ? "Ocultar" : "Ver"}
        </button>
      )}
    </div>
  );
};

export const Users = () => {
  const dispatch = useDispatch();
  const role = useSelector(
    (state) => state.aplicationConfig.userConfig.userData?.role,
  );
  const canManage = role === "admin";
  const [roleFilter, setRoleFilter] = useState("");
  const [invitingId, setInvitingId] = useState(null);
  const invitationLock = useRef(false);
  const sendInvitation = async (userId) => {
    if (!canManage || invitationLock.current) return;
    invitationLock.current = true;
    setInvitingId(userId);
    try {
      const response = await resendUserInvitation(userId);
      if (response?.error !== false)
        throw Error(
          response?.message ||
            "No se pudo enviar la invitación. Vuelve a intentarlo.",
        );
      dispatch(
        setAlert({
          type: "success",
          title: "Invitación enviada",
          message:
            "El usuario recibirá un enlace para establecer su contraseña.",
        }),
      );
    } catch (failure) {
      dispatch(
        setAlert({
          type: "error",
          title: "No se pudo enviar la invitación",
          message: failure.message,
        }),
      );
    } finally {
      invitationLock.current = false;
      setInvitingId(null);
    }
  };
  const [data, setData] = useState([]);
  const [readStatus, setReadStatus] = useState("loading");
  const [panelContent, setPanelContent] = useState(null);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState("");
  const inFlight = useRef(false);

  const saveUser = async (request) => {
    if (!canManage || inFlight.current) return;
    inFlight.current = true;
    setPending(true);
    setError("");
    try {
      const response = await request();
      if (response?.error !== false)
        throw new Error(
          response?.message ||
            "No se pudo guardar. Revisa los datos y vuelve a intentarlo.",
        );
      if (response.data?.invitationSent === false) {
        dispatch(
          setAlert({
            type: "error",
            title: "Usuario creado; invitación pendiente",
            message:
              "No se pudo enviar el correo. Usa Reenviar invitación en su ficha del listado; no repitas el alta.",
          }),
        );
      } else if (response.data?.invitationSent === true) {
        dispatch(
          setAlert({
            type: "success",
            title: "Usuario creado",
            message:
              "Se ha enviado la invitación para establecer su contraseña.",
          }),
        );
      }
      setPanelContent(null);
      await query();
    } catch (failure) {
      setError(failure.message || "No se pudo guardar. Comprueba la conexión.");
    } finally {
      inFlight.current = false;
      setPending(false);
    }
  };

  const getUserDataPanel = (userData = null) => {
    const data = {
      email: document.getElementById("email")?.value || "",
      fullname: document.getElementById("name")?.value || "",
      phone: document.getElementById("phone")?.value || "",
      role: document.getElementById("role")?.value || "",
      pin: document.getElementById("pinCode")?.value || userData?.pin || "",
      activePin:
        document.getElementById("pinActivation")?.checked ??
        Boolean(userData?.activePin ?? true),
      platformPermissions: {
        ...userData?.platformPermissions,
        tpv: document.getElementById("platform-tpv")?.checked || false,
        shop:
          userData?.platformPermissions?.shop === true ||
          userData?.platformPermissions?.shop === 1,
        kitchen: document.getElementById("platform-kitchen")?.checked || false,
        delivery:
          document.getElementById("platform-delivery")?.checked || false,
      },
    };
    return data;
  };

  /*********** API REQUESTS ************/
  const query = async () => {
    setReadStatus("loading");
    try {
      const response = await getUsers();
      if (
        response?.error !== false ||
        !response.data ||
        !Array.isArray(response.data.owners) ||
        !Array.isArray(response.data.corpUsers)
      )
        throw Error();
      setData(response.data);
      setReadStatus("ready");
    } catch {
      setReadStatus("error");
    }
  };

  const handleCreateUser = async () => {
    const payload = getUserDataPanel();
    await saveUser(() => createUser(payload));
  };

  const handleUpdateUser = async (data) => {
    const payload = getUserDataPanel(data);
    await saveUser(() => updateUser(data.userId, payload));
  };

  const handleDeleteUser = async (user) => {
    if (
      !canManage ||
      inFlight.current ||
      !window.confirm(`¿Eliminar a ${user.fullname || "este usuario"}?`)
    )
      return;
    inFlight.current = true;
    setPending(true);
    try {
      const response = await deleteUser(user.userId);
      if (response?.error !== false)
        throw new Error(response?.message || "No se pudo eliminar el usuario.");
      await query();
    } catch (failure) {
      dispatch(
        setAlert({
          type: "error",
          title: "No se pudo eliminar el usuario",
          message: failure.message,
        }),
      );
    } finally {
      inFlight.current = false;
      setPending(false);
    }
  };

  useEffect(() => {
    query();
  }, []);

  useEffect(() => {
    if (!canManage) setPanelContent(null);
  }, [canManage]);

  const closePanelContent = () => {
    if (inFlight.current) return;
    setPanelContent(null);
  };

  const handlePanelUser = (data) => {
    if (!canManage || pending) return;
    setError("");
    setPanelContent(data);
  };

  const displayRole = (user) =>
    user.role === "admin"
      ? "Administrador"
      : user.role === "manager"
        ? "Encargado"
        : user.role === "employee"
          ? "Empleado"
          : user.role || "Sin rol";
  const users = [
    ...(data?.owners || []).map((user) => ({
      ...user,
      isOwner: true,
      displayRole: displayRole(user),
    })),
    ...(data?.corpUsers || [])
      .filter(
        (user) =>
          !(data?.owners || []).some((owner) => owner.userId === user.userId),
      )
      .map((user) => ({
        ...user,
        isOwner: false,
        displayRole: displayRole(user),
      })),
  ];
  const visibleUsers = users.filter(
    (user) => !roleFilter || user.role === roleFilter,
  );
  return (
    <section className="usersReference">
      <header className="usersReferenceHeader">
        <div>
          <h2>Usuarios y permisos</h2>
          <p>
            Quién trabaja en el negocio, con qué rol, a qué plataformas accede y
            su PIN.
          </p>
        </div>
        <button
          type="button"
          className="usersAdd"
          disabled={!canManage || readStatus !== "ready" || pending}
          onClick={() => handlePanelUser({ userId: null })}
        >
          <GoPlus aria-hidden="true" /> Añadir usuario
        </button>
      </header>
      {!canManage && (
        <p className="usersReadOnly">
          <LuLockKeyhole aria-hidden="true" /> Solo lectura: tu rol no permite
          modificar usuarios.
        </p>
      )}
      {readStatus === "loading" && <p role="status">Cargando usuarios…</p>}
      {readStatus === "error" && (
        <div role="alert">
          No se pudieron cargar los usuarios.{" "}
          <button type="button" onClick={query}>
            Reintentar usuarios
          </button>
        </div>
      )}
      {readStatus === "ready" && (
        <>
          <details className="usersRoleFilter">
            <summary>Filtrar por rol</summary>
            <label>
              Rol
              <select
                value={roleFilter}
                onChange={(event) => setRoleFilter(event.target.value)}
              >
                <option value="">Todos los roles</option>
                <option value="admin">Administrador</option>
                <option value="manager">Encargado</option>
                <option value="employee">Empleado</option>
              </select>
            </label>
          </details>
          <div className="usersTableCard">
            <div
              className="usersTableScroll"
              role="region"
              aria-label="Listado de usuarios y permisos"
              // Keyboard access to the horizontally scrolling table.
              // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
              tabIndex={0}
            >
              <table>
                <thead>
                  <tr>
                    <th scope="col">Nombre</th>
                    <th scope="col">Email</th>
                    <th scope="col">Teléfono</th>
                    <th scope="col">Rol</th>
                    <th scope="col">Plataformas</th>
                    <th scope="col">PIN</th>
                    <th scope="col">Acceso con PIN</th>
                    {canManage && (
                      <th scope="col">
                        <span className="visually-hidden">Acciones</span>
                      </th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {visibleUsers.map((user) => (
                    <tr key={user.userId}>
                      <td>
                        <strong>{user.fullname || "Sin nombre"}</strong>
                        {user.isOwner && (
                          <span className="usersOwnerBadge">Propietario</span>
                        )}
                      </td>
                      <td>{user.email || "—"}</td>
                      <td>{user.phone || "—"}</td>
                      <td>
                        <span
                          className={`usersRoleBadge ${user.role === "admin" ? "usersAdminRole" : ""}`}
                        >
                          {user.displayRole}
                        </span>
                      </td>
                      <td className="usersPlatforms">
                        {user.platformPermissions
                          ? [
                              ["tpv", "TPV"],
                              ["kitchen", "Gestor de pedidos"],
                              ["delivery", "Repartidor"],
                              ["shop", "Tienda"],
                            ]
                              .filter(
                                ([key]) =>
                                  user.platformPermissions[key] === true ||
                                  user.platformPermissions[key] === 1,
                              )
                              .map(([, label]) => label)
                              .join(" · ") || "Sin plataformas"
                          : "—"}
                      </td>
                      <td>
                        <PinCell
                          pin={user.pin}
                          allowed={canManage}
                          name={user.fullname || "usuario"}
                        />
                      </td>
                      <td>
                        <span
                          className={`usersPinBadge ${user.activePin === true || user.activePin === 1 ? "usersPinActive" : ""}`}
                        >
                          {user.activePin === true || user.activePin === 1
                            ? "PIN activo"
                            : user.activePin === false || user.activePin === 0
                              ? "PIN desactivado"
                              : "Sin información"}
                        </span>
                      </td>
                      {canManage && (
                        <td className="usersActionsCell">
                          <details className="usersRowMenu">
                            <summary
                              aria-label={`Acciones de ${user.fullname || "usuario"}`}
                            >
                              •••
                            </summary>
                            <div>
                              <button
                                type="button"
                                disabled={pending}
                                onClick={() => handlePanelUser(user)}
                              >
                                Editar
                              </button>
                              {user.role === "admin" && (
                                <button
                                  type="button"
                                  disabled={invitingId !== null || pending}
                                  onClick={() => sendInvitation(user.userId)}
                                >
                                  {invitingId === user.userId
                                    ? "Enviando…"
                                    : "Reenviar invitación"}
                                </button>
                              )}
                              <button
                                type="button"
                                disabled={pending}
                                onClick={() => handleDeleteUser(user)}
                              >
                                Eliminar
                              </button>
                            </div>
                          </details>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
              {visibleUsers.length === 0 && (
                <p className="usersEmpty">No hay usuarios con este filtro.</p>
              )}
            </div>
            <footer>
              {visibleUsers.length}{" "}
              {visibleUsers.length === 1 ? "usuario" : "usuarios"}
            </footer>
          </div>
        </>
      )}
      {panelContent !== null && (
        <Popup
          isOpen={true}
          label={
            panelContent.userId === null ? "Añadir usuario" : "Editar usuario"
          }
          update={
            panelContent.userId === null
              ? handleCreateUser
              : () => handleUpdateUser(panelContent)
          }
          togglePopup={closePanelContent}
          busy={pending}
          content={
            <>
              <fieldset disabled={pending} className="usersEditionFields">
                <EditionUser data={panelContent} />
              </fieldset>
              {error && <p role="alert">{error}</p>}
              {pending && <p role="status">Guardando usuario…</p>}
            </>
          }
        />
      )}
    </section>
  );
};
